module.exports = __webpack_public_path__ + "img/1d01bc47915ce25c21393efb02b54993.png";